import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLogout } from "@/apis/auth.ts";
import { useAuthStore } from "@/stores/use-auth-store.ts";
import { Menu } from "@/components/sidebar/menu.tsx";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { Button } from "@/components/ui/button.tsx";
import { LogoutCombobox } from "@/components/combobox/logout-combobox.tsx";
import IcoMenu from "@/assets/icons/ico-menu.svg?react";
import IcoClose from "@/assets/icons/ico-close.svg?react";

export function MobileMenuSidebar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const { mutate: logout } = useLogout();
  const userId = useAuthStore((state) => state.userId);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <Drawer direction="right" open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button variant="outline">
          <IcoMenu />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <div className="flex items-center justify-between gap-2">
            <DrawerTitle>
              <LogoutCombobox userId={userId || ''} label="로그아웃" onLogout={logout}  />
            </DrawerTitle>
            <DrawerClose asChild>
              <Button variant="outline" size="sm_icon" className="bg-transparent">
                <IcoClose />
              </Button>
            </DrawerClose>
          </div>
        </DrawerHeader>
        <Menu />
      </DrawerContent>
    </Drawer>
  )
}